module.exports = __webpack_public_path__ + "img/linkinpark.7271fae3.jpg";